import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseComponent, ConfirmationDialogComponent, IdCodeNameModel, LeModalService} from "common-shared";
import {BehaviorSubject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-toolbar-edit-buttons',
  templateUrl: './toolbar-edit-buttons.component.html',
  styles: [
  ],
  host: {
    class: 'flex-grow-1'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarEditButtonsComponent extends BaseComponent implements OnInit {
  @Input() showForceSave = false;
  @Input() showSave = true;
  @Input() showDelete = true;
  @Input() isForceSaveShown$ = new BehaviorSubject<boolean>(false);
  @Input() saveState$ = new BehaviorSubject<boolean>(true);
  @Input() deleteState$ = new BehaviorSubject<boolean>(true);
  @Output() forceSave = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute, private modalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
  }

  deleteClicked() {
    const displayName = (this.route.snapshot.data.entity as IdCodeNameModel)?.DisplayName ?? 'this entry';
    const modalRef = this.modalService.show(ConfirmationDialogComponent, {
      initialState: {
        description: `Delete ${displayName}?`,
        options: {hasSafetyCheck: true}
      },
      class: 'modal-sm'
    });
    modalRef.onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(confirmation => {
      if (confirmation.data) {
        this.delete.emit(true);
      }
    });
  }
}
